import { Text } from "@smoothincorg/smooth-ui"
import React from "react"
import { PokeLoading } from "src/components/Loading"
import { generateClassName } from "src/lib/ui/class-name-helper"
import styled from "styled-components"

type Props = JSX.IntrinsicElements["button"] & {
  loading?: boolean
}

const { getRootClassName } = generateClassName("SubmitButton")

// eslint-disable-next-line react/display-name
const Component = React.memo<Props>((props) => {
  const { children, loading, ...restProps } = props
  return (
    <button {...restProps} className={getRootClassName(props)}>
      <Text size={14} weight="bold">
        {children}
      </Text>
      {loading && (
        <div
          style={{
            position: "relative",
            width: 30,
            height: 30,
          }}
        >
          <PokeLoading height={30} text={false} />
        </div>
      )}
    </button>
  )
})

const StyledComponent = styled(Component)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  height: 50px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  > .smooth-ui-Text {
    margin-right: 8px;
  }
`

export const SubmitButton = StyledComponent
